module.exports = __webpack_public_path__ + "static/media/general-button-mobile.4b1e83b7.svg";